<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">
        <template v-if="fillInInstructions == false">維修狀態</template>
        <template v-else-if="fillInInstructions == true">維修說明填寫</template>
      </div>
      <div style="margin-top: 2rem">
        <div class="row">
          <template v-if="fillInInstructions == false">
            <basic />
          </template>
          <template v-else-if="fillInInstructions == true">
            <write />
          </template>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import basic from "@/components/deviceManagement/maintainHistory/maintainStatus/basic.vue";
import write from "@/components/deviceManagement/maintainHistory/maintainStatus/write.vue";
import { computed, provide, ref, watch } from "vue";
import store from "@/store";
export default {
  components: {
    commonTable,
    basic,
    write,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const axiosMaintainStatusFileResult = computed(
      () => store.getters["commonAxios/get_axiosMaintainStatusFileResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      axiosActionMaintainStatusFile: async (payload) => {
        await store.dispatch(
          "commonAxios/axiosActionMaintainStatusFile",
          payload
        );
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const fillInInstructions = ref(null);
    const maintainData = ref(null);
    const currentRepairDeviceTableFields = ref([
      {
        key: "item",
        label: "項次",
        thStyle: {
          "min-width": "50px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "device",
        label: "機台",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "time",
        label: "報修時間",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "category",
        label: "維修別",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "description",
        label: "故障/異常描述",
        thStyle: {
          "min-width": "250px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
          "white-space": "pre-line",
        },
      },
      {
        key: "reportPersonnel",
        label: "報修人員",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "personnel",
        label: "維修人員",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "維修開始時間",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const currentRepairDeviceTableItems = ref([
      // {
      //   device: "鍛造1",
      //   time: "2023-11-10 11:20:00",
      //   category: 3,
      //   description: "入料夾手(Q1)機械異常維修",
      //   personnel: "小明1號",
      //   startTime: "2023-11-10 11:35:00",
      // },
      // {
      //   device: "退火3",
      //   time: "2023-11-12 10:47:00",
      //   category: 2,
      //   description: "排煙風機維修",
      //   personnel: "",
      //   startTime: "",
      // },
      // {
      //   device: "環形爐",
      //   time: "2023-11-13 14:35:00",
      //   category: 2,
      //   description: "夾手冷卻水管漏水",
      //   personnel: "",
      //   startTime: "",
      // },
    ]);

    const maintenanceInstructionsTableFields = ref([
      {
        key: "item",
        label: "項次",
        thStyle: {
          "min-width": "50px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "device",
        label: "機台",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "維修開始時間",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "維修結束時間",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "category",
        label: "維修別",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "personnel",
        label: "維修人員",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalTime",
        label: "維修總時長",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const maintenanceInstructionsTableItems = ref([
      // {
      //   abn_start_time: "2023-11-13 10:00:00",
      //   device: "保溫1",
      //   deviceID: "PH01",
      //   startTime: "2023-11-13 10:00:00",
      //   endTime: "2023-11-13 12:15:30",
      //   category: 3,
      //   personnel: "小明1號",
      //   totalTime: "2小時15分30秒",
      // },
      // {
      //   abn_start_time: "2023-11-14 10:00:00",
      //   device: "環形爐",
      //   deviceID: "R03",
      //   startTime: "2023-11-14 13:00:00",
      //   endTime: "2023-11-14 18:20:30",
      //   category: 2,
      //   personnel: "小明1號",
      //   totalTime: "5小時20分30秒",
      // },
    ]);

    const queryMaintainData = () => {
      // 查當前報修機台及待填維修說明資料
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "QueryMaintainStatusUnrepair";
      methods.triggerLoadingBar();
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] != "ok") {
          methods.setTimeoutAlert(result["Response"]);
        } else {
          let QueryTableData = result.QueryTableData;
          currentRepairDeviceTableItems.value =
            QueryTableData["currentRepairDevice"];
          maintenanceInstructionsTableItems.value =
            QueryTableData["maintenanceInstructions"];
          fillInInstructions.value = false;
        }
        methods.triggerLoadingBar();
      });
    };

    const updateMaintainStatus = (
      abn_start_time = "",
      deviceID = "",
      textData,
      attachments = []
    ) => {
      console.log(abn_start_time, deviceID);
      if (
        abn_start_time == "" ||
        deviceID == "" ||
        abn_start_time == null ||
        deviceID == null
      ) {
        methods.setTimeoutAlert("請重新整理頁面");
        methods.triggerLoadingBar();
        return;
      }
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateMaintainStatusReason";
      params["abn_start_time"] = abn_start_time;
      params["deviceID"] = deviceID;
      params["textData"] = textData;
      params["attachments"] = attachments;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] != "ok") {
          methods.setTimeoutAlert(result["Response"]);
        } else {
          fillInInstructions.value = false;
        }
        methods.triggerLoadingBar();
      });
    };
    const checkWrite = (abn_start_time, deviceID, dir, textData, files) => {
      if (textData == null || textData == "") {
        methods.setTimeoutAlert("請輸入維修說明");
        return;
      }

      methods.triggerLoadingBar();
      const formData = new FormData();
      let attachments = [];
      // 將選取的檔案加入 FormData 中
      for (let i = 0; i < files.length; i++) {
        if (files[i] == null) {
          continue;
        }
        formData.append("files[]", files[i]);
        attachments.push(files[i].name);
      }
      formData.append("dir", dir);

      if (attachments.length != 0) {
        methods.axiosActionMaintainStatusFile(formData).then(() => {
          let result = axiosMaintainStatusFileResult.value;
          console.log(result);
          let response = result.Response;
          if (response != "ok") {
            methods.triggerLoadingBar();
            methods.setTimeoutAlert("請重新上傳檔案");
            return;
          }
          updateMaintainStatus(abn_start_time, deviceID, textData, attachments);
        });
      } else {
        updateMaintainStatus(abn_start_time, deviceID, textData);
      }
      return;
    };
    const cancelWrite = () => {
      fillInInstructions.value = false;
    };

    const getMaintainData = (itemData) => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "GetMaintainDeviceData";
      params["abn_start_time"] = itemData.abn_start_time;
      params["deviceID"] = itemData.deviceID;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;
        if (result["Response"] == "ok") {
          maintainData.value = {
            device: result["QueryTableData"].device,
            deviceID: result["QueryTableData"].deviceID,
            category: result["QueryTableData"].category,
            description: result["QueryTableData"].description,
            personnel: result["QueryTableData"].personnel,
            time: result["QueryTableData"].time,
            abn_start_time: result["QueryTableData"].abn_start_time,
            dir:
              result["QueryTableData"].deviceID +
              "_" +
              result["QueryTableData"].startTime.replace(/[- :]/g, ""),
          };
          fillInInstructions.value = true;
        } else {
          methods.setTimeoutAlert("請稍後嘗試");
          fillInInstructions.value = false;
        }
      });
    };
    const completeWorkRowClick = (itemData) => {
      getMaintainData(itemData);
    };

    const commonMethods = {
      checkWrite: checkWrite,
      cancelWrite: cancelWrite,
      getMaintainData: getMaintainData,
      completeWorkRowClick: completeWorkRowClick,
    };

    watch(fillInInstructions, (newValue) => {
      if (newValue != false) {
        return;
      }
      queryMaintainData();
    });
    fillInInstructions.value = false;

    provide("fillInInstructions", fillInInstructions);
    provide("maintainData", maintainData);
    provide("commonMethods", commonMethods);
    provide("currentRepairDeviceTableFields", currentRepairDeviceTableFields);
    provide("currentRepairDeviceTableItems", currentRepairDeviceTableItems);
    provide(
      "maintenanceInstructionsTableFields",
      maintenanceInstructionsTableFields
    );
    provide(
      "maintenanceInstructionsTableItems",
      maintenanceInstructionsTableItems
    );
    return {
      fillInInstructions,
      maintainData,
      completeWorkRowClick,
    };
  },
};
</script>

<style></style>
